export const FILTER_COLORS: { [key: string]: string } = {
  hd_acne: 'rgb(67, 165, 220)',
  hd_wrinkle: 'rgb(106, 221, 84)',
  hd_pore: 'rgb(93, 207, 166)',
  hd_moisture: 'rgb(35, 217, 227)',
  hd_redness: 'rgb(255, 46, 0)',
  hd_oiliness: 'rgb(255, 139, 12)',
  hd_texture: 'rgb(205, 134, 242)',
  hd_dark_circle: 'rgb(119, 123, 139)',
  hd_eye_bag: 'rgb(205, 86, 117)',
  hd_firmness: 'rgb(252, 133, 254)',
  hd_droopy_upper_eyelid: 'rgb(229, 69, 255)',
  hd_droopy_lower_eyelid: 'rgb(203, 46, 131)',
  hd_radiance: 'rgb(170, 187, 205)',
  hd_age_spot: 'rgb(1, 192, 254)',
  skin_type: 'rgb(207, 155, 142)',
};

export function getFilterColor(filterKey: string): string {
  return FILTER_COLORS[filterKey] || 'rgb(119, 123, 139)';
}

export function getFilterColors(filterKeys: string[]): string[] {
  return filterKeys.map((key) => getFilterColor(key));
}

/**
 * Filter colour darkened just enough to carry a white label at AA 4.5:1.
 * Same hue as getFilterColor; used for the active score badge only.
 */
export function getFilterFillColor(filterKey: string): string {
  const base = (getFilterColor(filterKey).match(/\d+/g) || []).map(Number);
  const lum = (c: number[]) => {
    const [lr, lg, lb] = c.map((v) => {
      const s = v / 255;
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * lr + 0.7152 * lg + 0.0722 * lb;
  };
  for (let k = 100; k > 0; k--) {
    const c = base.map((v) => Math.floor((v * k) / 100));
    if (1.05 / (lum(c) + 0.05) >= 4.5) return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
  }
  return getFilterColor(filterKey);
}
